/* eslint-disable camelcase */
import * as React from 'react'
import { ReactElement } from 'react'
import { connect } from 'react-redux'
import { find } from 'lodash'
import { withRouter } from '../../../../../withRouter'
import useFeatureFlags from 'hooks/useFeatureFlags'
import Operations from '../../../../../operations'
import Selectors from '../../../../../selectors'

// Import both versions
import { ConsentFormScreen as NewVersion } from './ConsentFormScreenNew'
import { ConsentFormScreen as LegacyVersion } from './ConsentFormScreenLegacy'

const ConsentFormScreenWrapper = (props: any): ReactElement => {
  const featureFlags = useFeatureFlags({ flagNames: ['informed_consent'] }).data
  const isInformedConsentEnabled =
    featureFlags['informed_consent']?.enabled || false

  // Return the appropriate version based on feature flag
  if (isInformedConsentEnabled) {
    return <NewVersion {...props} />
  }

  return <LegacyVersion {...props} />
}

const mapStateToProps = (
  state: {
    data: any
    global: any
  },
  props: {
    router: {
      params: any
    }
  }
) => {
  const form = find(state?.data['consent-forms'], {
    id: props?.router?.params?.consent_form_id
  })
  return {
    logs: find(Selectors.getResidentConsentForms(state), {
      id: props?.router?.params?.consent_form_id
    })?.logs,
    consentForm: form,
    home: state?.global?.home,
    signatureItem: find(state.data['log-category-items'], {
      itemId: 'signature'
    }),
    resident: find(state?.data.residents, {
      id: form?.resident
    }),
    lastReviewCarer: find(state?.data.carers, {
      id: form?.editedBy
    })
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  fetchResidentConsentFormByID: (id: string) => {
    dispatch(Operations.loadListItem('consent-forms', id))
  },
  updateConsent: ({
    isRefused,
    comment,
    editedBy,
    editedOn,
    nextReviewDate,
    consentForm,
    consentStatus,
    carePlans,
    statusReason,
    lastReviewed
  }: any) =>
    dispatch(
      Operations.updateListItem({
        listId: 'consent-forms',
        itemId: consentForm.id,
        successMsg: '',
        json: {
          isRefused,
          reviewComment: comment,
          editedBy,
          editedOn,
          nextReviewDate,
          consentStatus,
          carePlans,
          statusReason,
          lastReviewed
        }
      })
    )
})

export default withRouter(
  connect<any, any, any>(
    // @ts-ignore
    mapStateToProps,
    mapDispatchToProps
  )(ConsentFormScreenWrapper)
)
